import { render, staticRenderFns } from "./admin_dashboard.vue?vue&type=template&id=732f91ca&scoped=true&"
import script from "./admin_dashboard.vue?vue&type=script&lang=js&"
export * from "./admin_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin_dashboard.vue?vue&type=style&index=0&id=732f91ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f91ca",
  null
  
)

export default component.exports